module.exports = __webpack_public_path__ + "static/media/ser-arvore-1.ad35036f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ser-arvore-1.jpg
// module id = 168
// module chunks = 1